module.exports = __webpack_public_path__ + "img/jacek-giezek.876e053a.png";